<template>
  <div :id="this.$route.name">
    <Loading v-if="loadingRender"></Loading>
    <card tools toolsColumns>
      <template v-slot:header>
        <h5 class="d-inline">
          لیست محصولات مشتری
          <span class="text-secondary">{{ DataAxios.CustomerName }}</span>
        </h5>
        <h5 class="d-inline">طی شماره قرارداد ({{ DataAxios.Id }})</h5>
        <hr />
      </template>
      <template v-slot:content>
        <BnpGrid
          v-if="$store.state.renderComponentGrid"
          :hasRowNum="true"
          :propsColumn="Column"
          :propsRows="Rows"
          :Selectable="false"
        >
        </BnpGrid>
      </template>
    </card>
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">اضافه کردن محصول</h4>
        <hr />
      </template>
      <template v-slot:btnCustome>
        <a
          class="d-inline float-left mx-2 mt-1"
          href="javascript:;"
          @click="AddRow()"
          title="ردیف جدید"
        >
          <h4>
            <i
              class="fad fa-cart-plus"
              style="color: var(--logo-color) !important"
            ></i>
          </h4>
        </a>
      </template>
      <template v-slot:content>
        <form>
          <div class="row" id="DetailCustomerProductRow">
            <div class="col-md-4 col-12">
              <small id="LblTblCostomer">مربوط به مشتری</small>
              <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                :rownumintable="3"
                :defaultvalue="DataAxios.TblCustomerId"
                :action="'TblCrmCombo/GetCostomerId/' + DataAxios.TblCustomerId"
                :method="'POST'"
                :idinput="'TblCostomer'"
                :keyItem="'TblCostomer'"
                :disabled="false"
              >
              </SearchableCombo>
            </div>
            <div class="col-md-3 col-12">
              <small id="LblTblProductsId">محصول</small>
              <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                :rownumintable="3"
                :defaultvalue="DataAxios.TblProductsId"
                @ResultCombo="GetResulTblProductsId"
                :action="'TblCrmCombo/GetProduct'"
                :method="'POST'"
                :idinput="'TblProductsId'"
                :keyItem="'TblProductsId'"
                :disabled="false"
              >
              </SearchableCombo>
            </div>
            <div class="col-md-1 col-12">
              <small id="LblCount">تعداد</small>
              <input
                dir="ltr"
                type="number"
                @keypress="$ValidNumber($event, 2)"
                class="form-control"
                id="txtCount"
                v-model="Count"
                tabindex="1"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-12">
              <small id="LblAmount">مبلغ</small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                @keyup="Amount = $PutCommatoInput_New($event);"
                class="form-control InputText 3ragham required"
                id="txtAmount"
                v-model="Amount"
                tabindex="2"
              />
            </div>
            <div class="col-md-3 col-12">
              <small id="LblDiscount">مبلغ تخفیف</small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                @keyup="Discount = $PutCommatoInput_New($event);"
                @focusout="FocusOutAmount($event)"
                class="form-control InputText 3ragham"
                id="txtDiscount"
                v-model="Discount"
                tabindex="3"
              />
            </div>
            <div class="col-md-3 col-12">
              <small id="LblTax">مبلغ مالیات </small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                class="form-control required"
                id="txtTax"
                v-model="Tax"
                tabindex="4"
                disabled
              />
            </div>
            <div class="col-md-3 col-12">
              <small id="LblToll">مبلغ عوارض </small>
              <input
                dir="ltr"
                type="text"
                @keypress="$ValidNumber($event, 15)"
                class="form-control required"
                id="txtToll"
                v-model="Toll"
                tabindex="5"
                disabled
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <small id="LblToll">مبلغ کل </small>
              <input
                dir="ltr"
                type="text"
                class="form-control required"
                id="txtTotallAmount"
                v-model="TotallAmount"
                tabindex="5"
                disabled
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <button
                class="btn btn-success float-left"
                @click.prevent="AddRow()"
                title="ردیف جدید"
              >
                اضافه کردن
              </button>
            </div>
          </div>
        </form>
      </template>
    </card>
    <card>
      <template v-slot:content>
        <div class="row">
          <div
            class="col-md-3 col-12"
            v-for="(item, index) in listProduct"
            :key="index"
          >
            <card-box>
              <template v-slot:cardbox-icon1>
                <i class="fas fa-gift"></i>
              </template>
              <template v-slot:b-dropdown-item>
                <b-dropdown-item
                  @click="Delete(item.TblProductsId)"
                  href="#"
                  class="text-center"
                  >حذف</b-dropdown-item
                >
              </template>
              <template v-slot:cardbox-body>
                <p class="card-text detail">{{ item.ProductName }}</p>
                <p class="card-text detail">
                  <i class="fas fa-coins"></i> مبلغ : {{ item.Amount }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-percent"></i> تخفیف : {{ item.Discount }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-cash-register"></i> مالیات : {{ item.Tax }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-cash-register"></i> عوارض : {{ item.Toll }}
                </p>
                <p class="card-text detail">
                  <i class="fas fa-sack-dollar"></i> مبغ کل :
                  {{ item.TotallAmount }}
                </p>
              </template>
            </card-box>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-3"></div>
          <div class="col-md-3"></div>
          <div class="col-md-3"></div>
          <div class="col-md-3 col-12">
            <button
              v-if="listProduct.length > 0"
              @click="submitProduct"
              class="btn-success btn w-100"
            >
              ثبت اطلاعات
            </button>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from "@/components/Card/Card.vue";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import CardBox from "@/components/CardBox/CardBox.vue";
import BtnSaveData from "@/components/BnpButtons/BtnSaveData.vue";
import Loading from "@/components/Loader/Loading.vue";
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
export default {
  components: { Card, SearchableCombo, CardBox, BtnSaveData, Loading, BnpGrid },
  data() {
    return {
      loadingRender: false,
      DataAxios: {},
      DataAxiosNew: {},
      DataAxios_Post: {
        Action: "CustomerProduct",
        Method: "Post",
        Token: this.$session.get("Token"),
        ArryfildValue: {},
      },
      Amount: "0",
      Count: 1,
      Tax: "0",
      Discount: "0",
      Toll: "0",
      TotallAmount: "0",
      listProduct: [],
      sumTotall: 0,
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: "frmCustomerProduct",
          ShowView: 0,
        },
        Method: "post",
        Action: "ReadGridColumns",
      },
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: "post",
        Action: "CustomerProduct/Index",
        Token: this.$session.get("Token"),
      },
      Rows: [],
      Column: [],
    };
  },
  created() {
    if (this.$route.params.Status == "Add") {
      this.DataAxios = this.$route.params.DataRow;
    }
  },
  beforeMount() {
    this.$GetColumns(this.DataAxoisCol, true)
      .then((data) => {
        this.Column = data;
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true;
        });
      });
  },
  mounted() {
    this.DataAxios.TblUserGrpIdInsert =
      this.$session.get("UserInfo").tblUserGrpId;
    var row = {};
    this.Rows = [];

    row.tblCustomerId = this.DataAxios.TblCustomerId;
    this.DataAxios_GetData.ArryfildValue = row;
    this.$PostData(this.DataAxios_GetData)
      .then((data) => {
        if (data.length > 0 && data[0].Id != null) {
          let dataFilter = data.filter(
            (x) => x.TblContractId == this.DataAxios.Id
          );
          for (let index = 0; index < dataFilter.length; index++) {
            this.Rows.push(dataFilter[index]);
          }
        } else {
          // console.log("No Data");
          this.Rows = [];
        }
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false;
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true;
        });
      });
  },
  methods: {
    GetResulTblProductsId(data) {
      this.DataAxios.ProductName = data.name;
      this.DataAxios.TblProductsId = data.id;
    },
    AddRow() {
      if (this.listProduct.length > 0) {
        this.sumTotall += Number(
          this.DataAxiosNew.TotallAmount.replace(/,/g, "").replace(/\./g, "")
        );
        if (Number(this.sumTotall) <= Number(this.DataAxios.TotallAmount)) {
          var findItem = false;
          for (let index = 0; index < this.listProduct.length; index++) {
            if (
              this.listProduct[index].TblProductsId ==
              this.DataAxiosNew.TblProductsId
            ) {
              findItem = true;
            }
            if (findItem == false) {
              this.listProduct.push(
                JSON.parse(JSON.stringify(this.DataAxiosNew))
              );
              this.$mySweetDefaultTost(
                "عملیات موفق",
                "آیتم مورد نظر شما به لیست محصولات اضافه گردید ",
                "success",
                1000
              );
              return;
            } else {
              this.$mySweetDefault(
                "عملیات ناموفق",
                "آیتم مورد نظر شما در لیست محصولات وجود دارد",
                "error",
                1500
              );
              return;
            }
          }
        } else {
          this.$mySweetDefault(
            "عملیات ناموفق",
            "جمع کل محصولات از جمع کل مبلغ قرارداد بیشتر است",
            "error",
            2500
          );
          return;
        }
      } else {
        if (
          Number(
            this.DataAxiosNew.TotallAmount.replace(/,/g, "").replace(/\./g, "")
          ) <= Number(this.DataAxios.TotallAmount)
        ) {
          this.sumTotall = Number(
            this.DataAxiosNew.TotallAmount.replace(/,/g, "").replace(/\./g, "")
          );
          this.listProduct.push(JSON.parse(JSON.stringify(this.DataAxiosNew)));
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "آیتم مورد نظر شما به لیست محصولات اضافه گردید ",
            "success",
            1000
          );
          return;
        } else {
          this.$mySweetDefault(
            "عملیات ناموفق",
            "جمع کل محصولات از جمع کل مبلغ قرارداد بیشتر است",
            "error",
            2500
          );
          return;
        }
      }
    },
    FocusOutAmount(e) {
      if (this.DataAxios.TblComboGrpId12 == 1227) {
        var Amount = this.Amount.replace(/,/g, "").replace(/\./g, "");
        var Discount =
          e.target.value != "0"
            ? e.target.value.replace(/,/g, "").replace(/\./g, "")
            : 0;
        var mabKol = Number(Amount) * Number(this.Count) - Number(Discount);
        var TotallAmount = mabKol;
        this.TotallAmount = this.$Comma3ragham(TotallAmount);

        this.DataAxios.Count = this.Count;
        this.DataAxios.Amount = this.Amount;
        this.DataAxios.Discount = this.Discount;
        this.DataAxios.Tax = this.Tax;
        this.DataAxios.Toll = this.Toll;
        this.DataAxios.TotallAmount = this.TotallAmount;
      } else {
        var Amount = this.Amount.replace(/,/g, "").replace(/\./g, "");
        var Discount =
          e.target.value != "0"
            ? e.target.value.replace(/,/g, "").replace(/\./g, "")
            : 0;
        var mabKol = Number(Amount) * Number(this.Count) - Number(Discount);
        var tax = Number(mabKol) * 0.07;
        var toll = Number(mabKol) * 0.03;
        this.Tax = this.$Comma3ragham(tax);
        this.Toll = this.$Comma3ragham(toll);
        var TotallAmount = mabKol + tax + toll;
        this.TotallAmount = this.$Comma3ragham(TotallAmount);

        this.DataAxiosNew.Count = this.Count;
        this.DataAxiosNew.Amount = this.Amount;
        this.DataAxiosNew.Discount = this.Discount;
        this.DataAxiosNew.Tax = this.Tax;
        this.DataAxiosNew.Toll = this.Toll;
        this.DataAxiosNew.TotallAmount = this.TotallAmount;
        this.DataAxiosNew.ProductName = this.DataAxios.ProductName;
        this.DataAxiosNew.TblProductsId = this.DataAxios.TblProductsId;
        this.DataAxiosNew.TblContractId = this.DataAxios.Id;
        this.DataAxiosNew.TblCustomerId = this.DataAxios.TblCustomerId;
        this.DataAxiosNew.TblUserGrpIdInsert =
          this.DataAxios.TblUserGrpIdInsert;
      }
    },
    Delete(id) {
      for (let index = 0; index < this.listProduct.length; index++) {
        if (this.listProduct[index].TblProductsId == id) {
          this.listProduct.splice(index, 1);
          return;
        }
      }
    },
    submitProduct() {
      this.loadingRender = true;
      let countok = 0;
      for (let index = 0; index < this.listProduct.length; index++) {
        const element = this.listProduct[index];
        this.DataAxios_Post.ArryfildValue = element;
        this.$PostData(this.DataAxios_Post)
          .then((result) => {
            if (result.status == "Ok") {
              countok++;
            }
          })
          .finally(() => {
            this.loadingRender = false;
            if (countok == this.listProduct.length) {
              this.$mySweetDefaultTost(
                "عملیات موفق",
                "محصول جدید با موفقیت ثبت شد",
                "success",
                3000
              );
              return;
            } else {
              this.$mySweetDefault(
                "عملیات ناموفق",
                "مشکل در اضافه کردن محصولات لطفا مجداد تلاش کنید",
                "error",
                1500
              );
              return;
            }
          });
      }
    },
  },
};
</script>
<style scoped></style>
